
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { scrollWatcher } from '~/helpers/scroll-watcher.js';
import { homePageWatcher } from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({
  name: "DescriptionInfoVideoBlock",

  data: function () {
    return {
      isPlay: false,
      isAnimate: false,
    }
  },

  mounted: function () {
    document.addEventListener('scroll', this.inFieldOfView);
  },

  unMounted: function () {
    document.removeEventListener('scroll', this.inFieldOfView);
  },

  computed: {
    information: function () {
      return this.values?.information || []
    },
    description: function () {
      return this.values?.description || ''
    },

    isVideo: function () {
      return Boolean(this.extras?.video)
    },
    isInformation: function () {
      return Boolean(this.information.length > 0)
    },
    title: function () {
      return this.values?.title ? this.values?.title : 'Ролик о нашей компании'
    },
    isHome: function () {
      return homePageWatcher(this.$route.fullPath)
    }
  },

  methods: {
    onPlayVideo: function () {
      if (this.isPlay) {
        return
      }
      if (!this.$refs.refVideo) {
        setTimeout(() => {
          this.onPlayVideo();
        }, 500);
        return;
      }

      this.isPlay = true;
      this.$refs.refVideo.play();
      this.$refs.refVideo.muted = false;
    },
    onPauseVideo: function () {
      this.$refs.refVideo.pause();
      this.$refs.refVideo.muted = true;
      this.isPlay = false;
    },
    inFieldOfView: function () {
      if (scrollWatcher('description-info-video-block')) {
        document.removeEventListener('scroll', this.inFieldOfView);
        this.isAnimate = true;
      }
    },
  }
})
